import i18n from '../../../i18n';
import { setTheme } from '../../../core/utils/globalTheme';
import { SAUDI_BRAND } from '../config/saudiBrandConfig';
import { QAWAEM_FAVICON } from '../config/qawaemAssets';

/**
 * Force Arabic RTL, light theme, and Qawaem branding when running the Saudi product.
 */
export function applySaudiBrandRuntime() {
  if (typeof document === 'undefined') return;

  document.documentElement.dir = SAUDI_BRAND.direction;
  document.documentElement.lang = SAUDI_BRAND.defaultLocale;
  document.documentElement.setAttribute('data-brand', 'qawaem');
  document.documentElement.classList.add('qawaem-root');

  setTheme('light');

  document.title = SAUDI_BRAND.browserTitle || `${SAUDI_BRAND.appName} — ${SAUDI_BRAND.appSubtitle}`;

  document.querySelectorAll('link[rel="manifest"]').forEach((link) => link.remove());
  document.querySelectorAll('meta[name="apple-mobile-web-app-capable"], meta[name="mobile-web-app-capable"]').forEach((el) => el.remove());

  const faviconHref = QAWAEM_FAVICON;
  document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]').forEach((link) => {
    link.href = faviconHref;
  });

  const appNameMeta = document.querySelector('meta[name="application-name"]');
  if (appNameMeta) appNameMeta.content = SAUDI_BRAND.appName;
  const appleTitleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (appleTitleMeta) appleTitleMeta.content = SAUDI_BRAND.appName;

  if (i18n.language !== SAUDI_BRAND.defaultLocale) {
    void i18n.changeLanguage(SAUDI_BRAND.defaultLocale);
  }
}

export default applySaudiBrandRuntime;
